export default class ChronoFaq {
  constructor() {
    console.log("ChronoFaq :: init");

    let main = document.querySelector("main.faq");

    let modal = document.querySelector(".faq-modal");
    let modalBg = modal.querySelector(".bg");
    let modalCloseBtns = modal.querySelectorAll(".close");
    let modalVideo = modal.querySelector("#modal-video");
    let modalVideoPhone = modal.querySelector(".phone");
    let modalVideoOverlay = modal.querySelector(".video-overlay");

    let listing = main.querySelector(".faq-list");
    let videos = main.querySelectorAll(".video-list .video");

    let filterChoices = [];
    let filtersToSend = [];
    let baseUrl = window.location.origin + window.location.pathname;

    let currentIndex;

    window.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        closeModal();
      }
    });

    addListeners();
    initFilters();

    if (window.location.search != "") {
      let params;
      // console.log(window.location.search.search('%7C'))
      if (window.location.search.search("%7C") != -1) {
        params = window.location.search
          .substring(window.location.search.indexOf("=") + 1)
          .split("%7C");
      } else {
        params = window.location.search
          .substring(window.location.search.indexOf("=") + 1)
          .split("|");
      }
      for (const param of params) {
        filterChoices = main.querySelectorAll(".filter");

        for (const filter of filterChoices) {
          if (filter.getAttribute("data-choice") === param) {
            filter.classList.add("selected");
            filtersToSend.push(filter.dataset.choice);
            filter.ariaChecked = "true";
          }
        }
      }
    }

    if (videos.length) {
      for (let i = 0; i < videos.length; i++)
        videos[i].addEventListener("click", onVideoClick);
    }

    modalBg.addEventListener("click", closeModal);
    // modalCloseBtns.addEventListener('click', closeModal);
    for (let i = 0; i < modalCloseBtns.length; i++) {
      modalCloseBtns[i].addEventListener("click", closeModal);
    }
    modalVideoPhone.addEventListener("click", playbackVideo);

    function addListeners() {
      let faqs = main.querySelectorAll(".faq-list .faq");

      if (faqs.length) {
        for (let i = 0; i < faqs.length; i++) {
          faqs[i].addEventListener("click", onFaqClick);
          faqs[i].addEventListener("keydown", function (e) {
            if (e.key === "Enter") {
              onFaqClick(e);
            }
          });
        }
      }
    }

    function onFaqClick(e) {
      let target = e.currentTarget;
      currentIndex = target.dataset.id;
      modal.querySelector(".title").innerHTML =
        target.querySelector(".title").innerHTML;
      modal.querySelector(".wysiwyg-container").innerHTML =
        target.querySelector(".content").innerHTML;

      showModal("faq");

      setTimeout(function () {
        modal.querySelector(".close").focus();
      }, 100);
    }

    function onVideoClick(e) {
      let target = e.currentTarget;
      modal.querySelector(".title").innerHTML =
        target.querySelector(".title").innerHTML;
      modal.querySelector(".wysiwyg-container").innerHTML =
        target.querySelector(".content").innerHTML;
      modalVideo.querySelector("source").src = target.dataset.src;
      modalVideo.load();
      showModal("video");
    }

    function showModal(type) {
      if (type == "faq") {
        modal.classList.add("js-faq");
        modal.classList.remove("js-video");
      } else {
        modal.classList.remove("js-faq");
        modal.classList.add("js-video");
      }
    }

    function closeModal() {
      modal.classList.remove("js-faq");
      modal.classList.remove("js-video");
      modalVideo.pause();
      modalVideoOverlay.classList.remove("playing");

      setTimeout(function () {
        let faqs = main.querySelectorAll(".faq");
        for (let i = 0; i < faqs.length; i++) {
          if (faqs[i].dataset.id == currentIndex) {
            faqs[i].focus();
          }
        }
      }, 100);
    }

    function playbackVideo() {
      if (modalVideoOverlay.classList.contains("playing")) {
        modalVideo.pause();
        modalVideoOverlay.classList.remove("playing");
      } else {
        modalVideo.play();
        modalVideoOverlay.classList.add("playing");
      }
    }
    //Filter FAQs by categories and display them
    function initFilters() {
      filterChoices = main.querySelectorAll(".filter");

      for (let i = 0; i < filterChoices.length; i++) {
        filterChoices[i].addEventListener("click", onFilterClick.bind(this));
      }
    }
    function onFilterClick(e) {
      e.preventDefault();
      let target = e.target;

      listing.style.opacity = "0";

      // Pour avoir un filtre "Toutes les FAQ"
      // if(target.dataset.choice=="all"){
      // 	for(let i = 0; i < filterChoices.length; i++){
      // 		filterChoices[i].classList.remove('selected');
      // 	}
      // 	target.classList.toggle('selected');
      // }else{
      // 	main.querySelector("#filterAll").classList.remove('selected');
      // 	target.classList.toggle('selected');
      // }

      if (target.classList.contains("selected")) {
        target.classList.toggle("selected");
        target.ariaChecked = "false";
      } else {
        let activeChoices = main.querySelectorAll(".filter.selected");
        if (activeChoices) {
          for (let i = 0; i < activeChoices.length; i++) {
            if (activeChoices[i].classList.contains("selected")) {
              activeChoices[i].classList.toggle("selected");
              activeChoices[i].ariaChecked = "false";
            }
          }
        }
        target.classList.toggle("selected");
        target.ariaChecked = "true";
      }

      getQuestions();
    }
    function getQuestions() {
      getChoices();

      let paramString = "";

      for (const param of filtersToSend) {
        paramString += param + "|";
      }
      const lastIndexOfL = paramString.lastIndexOf("|");
      const finalString =
        paramString.slice(0, lastIndexOfL) +
        paramString.slice(lastIndexOfL + 1);
      if (finalString != "") {
        window.history.replaceState(
          null,
          document.title,
          baseUrl + "?category=" + encodeURIComponent(finalString)
        );
      } else {
        window.history.replaceState(null, document.title, baseUrl);
      }

      axios
        .get("/wp-admin/admin-ajax.php?action=filterChronoFAQ", {
          params: {
            categories: filtersToSend,
            lang: window.location.pathname,
          },
        })
        .then((response) => {
          //Emit response to parent
          if (response.data.success) {
            serveQuestions(response.data);
            // console.log(response.data);
          } else console.error("Filters :: Failed to retrieve questions");
        })
        .catch((err) => console.error(err));
    }

    function getChoices() {
      filtersToSend = [];

      let activeChoices = main.querySelectorAll(".filter.selected");

      for (let i = 0; i < activeChoices.length; i++) {
        filtersToSend.push(activeChoices[i].dataset.choice);
      }

      if (filtersToSend.length == 1 && filtersToSend[0] == "all") {
        filtersToSend = [];
      }
    }
    function serveQuestions(response) {
      const questions = response.questions;
      console.log(response);

      if (questions.length) {
        listing.innerHTML = "";
        for (let i = 0; i < questions.length; i++) {
          const question = questions[i];
          // console.log(question);

          let newQuestion = `<div class="faq" tabindex="0" data-id="${i}">
					                        <div class="title">
					                            ${question.title}
					                        </div>
					                        <div class="content">${question.content}</div>
					                    </div>`;
          listing.insertAdjacentHTML("beforeend", newQuestion);
        }
        listing.style.opacity = "1";
        addListeners();
      }
    }
  }
}
